<template>
  <cobrand>
    <BusinessSwitchOverlay />
    <div class="bg-white h-100 mh-100vh d-flex flex-column g-5"
      :class="{'customized-affiliate': !!affiliateCustomizations}"
      :style="appStyleProps"
      >
      <div>
        <LayoutBase></LayoutBase>
      </div>
      <div v-if="!isEmbedded" class="d-none d-lg-block">
        <AppHeader></AppHeader>
      </div>
      <MarketplaceMobileNav class="marketplace-nav d-lg-none">
      <AppNav class="sign-out" :full="true" :hide-app-cta="true" />
      </MarketplaceMobileNav>
      <div id="app">
        <slot />
      </div>
      <div class="secondary-logo"></div>
    </div>
  </cobrand>
</template>

<script>
import AppHeader from '~/components/AppHeader.vue'
import AppNav from '~/components/AppNav.vue'
import Cobrand from '~/components/Cobrand.vue'
import LayoutBase from './base.vue'
import MarketplaceMobileNav from '~/components/marketplace/MarketplaceMobileNav.vue'
import { useRootStore } from '~/store/root'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import BusinessSwitchOverlay from '~/components/BusinessSwitchOverlay.vue'

export default {
  mounted() {},
  components: {
    AppHeader,
    AppNav,
    Cobrand,
    LayoutBase,
    MarketplaceMobileNav,
    BusinessSwitchOverlay,
  },
  setup() {
    const rootStore = useRootStore()
    const isEmbedded = rootStore?.authUser?.isEmbedded ?? false
    const affiliateStore = useAffiliateCustomizationStore()

    const { affiliateCustomizations, appStyleProps } = storeToRefs(affiliateStore)

    return {
      isEmbedded,
      appStyleProps,
      affiliateCustomizations
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/styles/affiliate-customizations/affiliate-customizations-app';
.back-link {
  color: $neutral-500;
  width: 80px;
}

.forward-link {
  color: $neutral-500;
  width: 80px;
}

.mh-100vh {
  min-height: 100vh;
}

#app {
  flex: 1 0 auto;
  padding-bottom: 80px;
  background-color: $app-body-background-color;
}

// We have to override some styles with important to get higher precedence than the scoped styles in the footer
#base-footer {
  .base-footer-bottom {
    margin: 0 auto;
    max-width: 1200px;
    background-color: $background-100 !important;
  }

  .text-container {
    padding: 10px 0 !important;
  }
}

:deep(.customized-affiliate) {
  @include affiliateCustomizedApp();
}
</style>

<style lang="scss">
/* Sticky Footer */
html,
body,
#__nuxt,
#main-flex {
  /* Any container housing the flexboxes needs to be AT LEAST 100% height! */
  min-height: 100vh;
}
</style>
